export default __webpack_public_path__ + "static/favicon-186a779ab9332bff5e0607f4ab868d3f.ico";